import type { Persona } from "./types";

/**
 * Map a route to the persona its content signals. Reading a page is itself evidence —
 * time on /protocol says "developer," time on /partnerships says "publishing" — so the
 * layout credits the matching topic for dwell on any page, with no per-page code.
 * Longest-prefix wins, so "/soft-binding/overview" matches "/soft-binding".
 */
const ROUTE_TOPICS: { prefix: string; topic: Persona }[] = [
  { prefix: "/protocol", topic: "developer" },
  { prefix: "/developers", topic: "developer" },
  { prefix: "/security-model", topic: "developer" },
  { prefix: "/warm", topic: "developer" },
  { prefix: "/compliance", topic: "standards" },
  { prefix: "/soft-binding", topic: "standards" },
  { prefix: "/zwc-watermark", topic: "standards" },
  { prefix: "/partnerships", topic: "publishing" },
  { prefix: "/executive-summary", topic: "publishing" },
  { prefix: "/licensing", topic: "publishing" },
  { prefix: "/sign", topic: "creator" },
  { prefix: "/scrivener-mcp", topic: "creator" },
  { prefix: "/pricing", topic: "writer" },
];

export function routeTopicFor(pathname: string): Persona | null {
  let best: { prefix: string; topic: Persona } | null = null;
  for (const entry of ROUTE_TOPICS) {
    if (pathname === entry.prefix || pathname.startsWith(entry.prefix + "/")) {
      if (!best || entry.prefix.length > best.prefix.length) best = entry;
    }
  }
  return best?.topic ?? null;
}
